import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=606f4a3d&scoped=true&"
import script from "./revenue.vue?vue&type=script&lang=js&"
export * from "./revenue.vue?vue&type=script&lang=js&"
import style0 from "./revenue.vue?vue&type=style&index=0&id=606f4a3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f4a3d",
  null
  
)

component.options.__file = "revenue.vue"
export default component.exports